import React from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';

import {
  PageSharesList,
  PageShare,
} from '../pages/shares';

const RouteShares = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <PageSharesList />
      </Route>
      <Route path={`${path}/:_id`}>
        <PageShare />
      </Route>
    </Switch>
  );
};

export default RouteShares;
